import React, { useLayoutEffect, useRef } from 'react';
import { CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ProfileBuilderWrapper.module.scss';

function ProfileBuilderWrapper(props) {
  const {
    titleMain,
    titleSecondary,
    text,
    component,
    progress,
    loading = false,
    children,
    redirectOnClose = '/dashboard',
    filled = false
  } = props;

  const ref = useRef(null);

  const stopPropagationUnder = (e) => e.stopPropagation();

  useLayoutEffect(() => {
    ref.current.scrollIntoView();
  }, []);

  return (
    <div ref={ref} className={`${styles.background} container-fluid`}>
      <div className={styles.offset}>
        <div className={`${styles.container} ${filled && styles.containerBlue} pb-5 text-center`}>
          <div className={`${loading ? styles.spinnerVisible : styles.spinnerHidden}`}>
            <CircularProgress onClick={stopPropagationUnder} color="primary" size={120} />
          </div>
          <Link to={redirectOnClose} className={`${styles.closeIcon} text-end`}>
            <CloseIcon className="cursor-pointer" />
          </Link>
          <h4 className={`pt-5 ${styles.blueFont}`}>{titleMain}</h4>
          <div className={`${styles.progressCustomisation} progress mt-5`}>
            <div
              className={`${styles.progressCustomisationBar} progress-bar`}
              role="progressbar"
              style={{ width: `${progress}%` }}
            />
          </div>
          {titleSecondary && <h5 className={`pt-5 ${styles.blueFont}`}>{titleSecondary}</h5>}
          {text && <p className={styles.greyFont}>{text}</p>}
          {component}
          {children}
        </div>
      </div>
    </div>
  );
}

export default ProfileBuilderWrapper;
